export const STATE_EVENTS = {
    created: "state_created",
    updated: "state_updated",
    deleted: "state_deleted",
    init: "state_init",
    sync: "state_sync",
};
//# sourceMappingURL=state.js.map